import { Image, Link, StyleSheet, Text, View } from '@react-pdf/renderer';
import { PDFPage } from 'PDF/components/Page';
import { WatermarkSvgBigComponent } from 'PDF/components/WatermarkBig';

interface IContactItem {
  imgSrc: string;
  info: string;
}

interface ILastPagePdfProps {
  contactData: IContactItem[][];
  logoUrl: string;
  sectionPicture?: string;
  isStandardOrLightTariff: boolean;
}

export const LastPagePdf = ({ contactData, logoUrl, sectionPicture, isStandardOrLightTariff }: ILastPagePdfProps) => {
  const filteredContactsInfo = contactData[0].filter((data) => data.info && data.info !== '+');

  const firstPartContacts = filteredContactsInfo.slice(0, 2);

  const secondPartContacts = filteredContactsInfo.slice(2);

  const addressInfo = contactData[1][0];

  return (
    <PDFPage paddings="0" isStandardOrLightTariff={isStandardOrLightTariff}>
      <View style={styles.container}>
        <View style={styles.mainContactsWrapper}>
          <View style={styles.contactsBlock}>
            <View style={styles.contactsInnerWrapper}>
              {firstPartContacts.map((row) => (
                <View key={row.imgSrc} style={styles.contactWrap}>
                  <Image src={row.imgSrc} style={styles.contactIcon} />
                  <Text style={styles.text}>{row.info}</Text>
                </View>
              ))}
            </View>
            {secondPartContacts.length > 0 && (
              <View style={styles.contactsInnerWrapper}>
                {secondPartContacts.map((row) => (
                  <View key={row.imgSrc} style={styles.contactWrap}>
                    <Image src={row.imgSrc} style={styles.contactIcon} />
                    <Text style={styles.text}>{row.info}</Text>
                  </View>
                ))}
              </View>
            )}
          </View>

          {addressInfo.info && (
            <View key={addressInfo.imgSrc} style={styles.contactWrap}>
              <Image src={addressInfo.imgSrc} style={styles.contactIcon} />
              <Text style={styles.text}>{addressInfo.info}</Text>
            </View>
          )}
        </View>
        <View style={styles.backgroundImageContainer}>
          <Image
            src={sectionPicture}
            style={styles.backgroundImage}
          />
          {!!logoUrl && (
            <View style={styles.logoContainer}>
              <Image src={logoUrl} style={styles.logo} />
            </View>
          )}
          {!isStandardOrLightTariff && (
            <Link fixed href="https://growexa.com" style={styles.watermarkLink}>
              <WatermarkSvgBigComponent />
            </Link>
          )}
        </View>
      </View>
    </PDFPage>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column-reverse',
    height: '100%',
  },
  logoContainer: {
    position: 'absolute',
    top: '37px',
    left: '36px',
  },
  logo: {
    maxWidth: '122px',
    maxHeight: '72px',
  },
  backgroundImageContainer: {
    flexGrow: 1,
    position: 'relative',
  },
  backgroundImage: {
    height: '100%',
    objectFit: 'cover',
    objectPositionX: 0,
    objectPositionY: 0,
  },
  contactWrap: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    width: '135px',
  },
  contactIcon: {
    minWidth: '14px',
    maxWidth: '14px',
    minHeight: '14px',
    maxHeight: '14px',
    padding: 1,
    marginTop: '1px',
  },
  text: {
    fontFamily: 'Noto',
    fontWeight: 300,
    fontSize: '11px',
    color: '#000',
    maxWidth: '140px',
    marginBottom: '20px',
  },
  mainContactsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '60px',
    borderTop: '0.75px solid #4E5D56',
    borderBottom: '0.75px solid #4E5D56',
    padding: '38px 36px 44px',
    margin: '8px 0px 43px',
  },
  contactsBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  contactsInnerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '60px',
  },

  watermarkLink: {
    position: 'absolute',
    top: '37px',
    right: '36px',
  },
});
